export const ObjectTypes = {
  PLAYER: "PLAYER",
  PROJECTILE: "PROJECTILE",
  ENEMY : "ENEMY",
  TRAIL: "TRAIL",
};

export const ObjectStateConstants = {
  IDLE: "IDLE",
  // GENERIC ANIMATING STATE FOR PROJECTILES
  ACTIVE: "ACTIVE",
  // PLACEHOLDER BETWEEN TRIGGERS
  ANIMATING: "ANIMATING",
  ATTACKING: "ATTACKING",
  CASTING_Q: "CASTING_Q",
  CASTING_E: "CASTING_E",
  CASTING_R: "CASTING_R",
  STUNNED: "STUNNED",
  DEATH: "DEATH",
};